import { useCallback, useEffect, useState } from 'react';
import { useCheckDeviceWidth } from '../../../utils/CheckDeviceWidth/checkDeviceWidth';
import { getTranslatedValue } from '../components/ManageColumnForm/utils';
import { createFilterType } from '../utils';
import { useAddFilter } from './useAddFilter';
var defaultVoidFunction = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return null;
};
var useQuickFilter = function (_a) {
    var _b, _c;
    var gridActions = _a.gridActions, gridSelectors = _a.gridSelectors, quickFilter = _a.quickFilter, displayColumnsDefinitions = _a.displayColumnsDefinitions, filters = _a.filters;
    var resetFilters = gridActions.resetFilters, _d = gridActions.addFilter, addFilter = _d === void 0 ? defaultVoidFunction : _d;
    var filter = gridSelectors.filter;
    var isMobile = useCheckDeviceWidth().isMobile;
    var _e = useState(''), searchedValue = _e[0], setSearchedValue = _e[1];
    var _f = useState(false), displayInput = _f[0], setDisplayInput = _f[1];
    var handleAddFilter = useAddFilter(addFilter);
    var quickFilterValues = quickFilter ? (_b = filter === null || filter === void 0 ? void 0 : filter[quickFilter]) === null || _b === void 0 ? void 0 : _b.value : undefined;
    var searchedColumnsDefinitions = (displayColumnsDefinitions === null || displayColumnsDefinitions === void 0 ? void 0 : displayColumnsDefinitions.find(function (item) { return item.name === quickFilter; })) || null;
    var filterType = createFilterType(searchedColumnsDefinitions || {});
    var filtersDefaultComparator = ((_c = filters === null || filters === void 0 ? void 0 : filters[filterType].defaultExtraProps) === null || _c === void 0 ? void 0 : _c.defaultComparator) || 'eq';
    var searchComparator = (quickFilterValues && quickFilterValues.comparator) || filtersDefaultComparator;
    var isMobileInputView = isMobile && displayInput;
    useEffect(function () {
        if (quickFilterValues) {
            setSearchedValue(quickFilterValues.value);
        }
        else {
            setSearchedValue('');
        }
    }, [quickFilterValues, quickFilter, setSearchedValue]);
    useEffect(function () {
        if (isMobile) {
            setDisplayInput(false);
        }
        else {
            setDisplayInput(true);
        }
    }, [isMobile]);
    var onChangeInputValue = useCallback(function (e) {
        setSearchedValue(e.target.value);
        var value = {
            comparator: searchComparator,
            value: e.target.value
        };
        searchedColumnsDefinitions && handleAddFilter(value, searchedColumnsDefinitions);
    }, [setSearchedValue, searchComparator, handleAddFilter, searchedColumnsDefinitions]);
    var onClear = useCallback(function () {
        setSearchedValue('');
        onChangeInputValue({ target: { value: '' } });
        if (isMobile) {
            setDisplayInput(false);
        }
        else {
            setDisplayInput(true);
        }
    }, [setSearchedValue, isMobile, onChangeInputValue, setDisplayInput]);
    var onDisplayInput = useCallback(function () {
        setDisplayInput(true);
    }, []);
    var onResetFilters = useCallback(function () {
        resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters();
        setSearchedValue === null || setSearchedValue === void 0 ? void 0 : setSearchedValue('');
    }, [resetFilters, setSearchedValue]);
    var translatedValue = getTranslatedValue(searchedColumnsDefinitions);
    return {
        searchedValue: searchedValue,
        translatedValue: translatedValue,
        onChangeInputValue: onChangeInputValue,
        onResetFilters: onResetFilters,
        onDisplayInput: onDisplayInput,
        displayInput: displayInput,
        onClear: onClear,
        isMobileInputView: isMobileInputView,
        isMobile: isMobile,
        filter: filter
    };
};
export default useQuickFilter;
